import React from 'react';
import { motion } from 'framer-motion';
import { TRANSFORMATIONS } from '../data/transformations';

/**
 * Galerie de transformations clients (images avant/après combinées).
 * Réutilisable sur /transformation et le tunnel /demarrer.
 * @param {number} limit  Nombre max de cartes à afficher.
 * @param {string} language  'fr' | 'en'
 * @param {string} columns  classes Tailwind pour la grille (def. 2/3 cols)
 */
const BeforeAfterGallery = ({ limit, language = 'fr', columns = 'sm:grid-cols-2 lg:grid-cols-3' }) => {
  const en = language === 'en';
  const items = limit ? TRANSFORMATIONS.slice(0, limit) : TRANSFORMATIONS;

  return (
    <div className={`grid grid-cols-1 ${columns} gap-5 items-start`} data-testid="before-after-gallery">
      {items.map((t, i) => (
        <motion.figure
          key={t.id}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ delay: Math.min(i * 0.06, 0.4) }}
          className="group relative overflow-hidden rounded-2xl border border-white/10 bg-zinc-900/50"
          data-testid={`transfo-card-${t.id}`}
        >
          <div className="overflow-hidden">
            <img
              src={t.image}
              alt={en ? `Before / after — ${t.result.en}` : `Avant / après — ${t.result.fr}`}
              loading="lazy"
              className="w-full h-auto block transition-transform duration-500 group-hover:scale-[1.03]"
            />
          </div>
          <figcaption className="px-4 py-3">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-bold text-white">{t.initials}</span>
              <span className="text-xs text-primary text-right">{t.result[en ? 'en' : 'fr']} · {en ? '6 months' : '6 mois'}</span>
            </div>
            {t.quote && (
              <p className="text-xs text-zinc-400 italic mt-1.5 leading-snug">« {t.quote[en ? 'en' : 'fr']} »</p>
            )}
          </figcaption>
        </motion.figure>
      ))}
    </div>
  );
};

export default BeforeAfterGallery;
